import BN from 'bn.js'

export function fromHexToString(value) {
  return fromHexToBigInt(value).toString()
}

export function fromHexToBigInt(value) {
  return BigInt(addHexPrefix(value))
}

export const addHexPrefix = (str) => {
  if (typeof str !== 'string') {
    return str
  }

  return str.startsWith('0x') ? str : '0x' + str
}

export const removeHexPrefix = (str) => {
  if (typeof str !== 'string' || str === '') {
    return str
  }

  return str.startsWith('0x') ? str.slice(2) : str
}

export const splitIn32BytesArray = (output) => {
  const trimmed = removeHexPrefix(output)
  const result = trimmed.match(/^([\da-f]{64})+$/gi)
  if (result) {
    return trimmed.match(/.{64}/g)
  }

  throw new Error(`${output} is not a 64 bytes hex that can be split`)
}

export const removeLeadingZeroes = (str) => str.replace(/^0+/, '')

// Deprecated, use BigInt
export const fromHexToBN = (str) => new BN(removeLeadingZeroes(removeHexPrefix(str)), 16)
